import Vue from 'vue';
import Errors from '../classes/errors';

Vue.component('owner-manual-search-component', {
    props: {
        manuals: Array,
    },

    data() {
        return {
            searchQuery: '',
            searchResults: null,
            vinError: false,
            awaitingSearch: false,
            errors: new Errors(),
        };
    },

    watch: {
        vinError(value) {
            if (!value) {
                this.errors.clear();
                return;
            }

            this.errors.record({ vin: ['owner-manual-error'] });
        },
    },

    mounted() {
        document.addEventListener('keydown', this.setSearchQueryOnEnter);
    },

    beforeDestroy() {
        document.removeEventListener('keydown', this.setSearchQueryOnEnter);
    },

    methods: {
        setSearchQueryOnEnter(event) {
            if (event.key === 'Enter') {
                this.setSearchQuery();
            }
        },
        throttledSearch() {
            if (!this.awaitingSearch) {
                setTimeout(() => {
                    this.search();
                    this.awaitingSearch = false;
                }, 500);
            }
            this.awaitingSearch = true;
        },
        setSearchQuery() {
            const input = this.$el.querySelector('#vin');
            this.searchQuery = input.value;
            this.search(input.value);
        },
        search(searchProperty) {
            this.vinError = false;
            const search = searchProperty || this.searchQuery;

            if (search.length !== 17 && search.length > 0) {
                this.vinError = true;
                return;
            }
            const searchString = search.slice(0, 9) + search[10];

            let results = [];
            this.manuals.forEach((current) => {
                current.codes.forEach((code) => {
                    // if the code contains a * shorten code and searchstring (non ZS models, like EHS: LSJA2439*N)
                    if (code[8] === '*') {
                        const shortCode =
                            code.slice(0, 8) + code.slice(9, code.length);

                        const shortSearchString =
                            searchString.slice(0, 8) +
                            searchString.slice(9, searchString.length);

                        if (shortCode === shortSearchString) {
                            current.manuals.forEach((manual) => {
                                results.push(manual);
                            });
                        }

                        return;
                    }

                    // otherwise use code and searchstring as is (ZS models: LSJW7409KZ)
                    if (code === searchString) {
                        current.manuals.forEach((manual) => {
                            results.push(manual);
                        });
                    }

                    return;
                });
            });

            this.searchResults = results;
        },
    },
});
